<template>
  <tr>
    <!-- FECHA -->
    <td>{{ fmtDate(payment.created_at) }}</td>
    <!-- PACIENTE  -->
    <td>
      <a :href="`/customer/${customer.id}/edit`" target="_blank" class="btn-link">
        {{ customer.full_name }}
      </a>
    </td>
    <!-- CUENTA -->
    <td>{{ account_name }}</td>
    <!-- IBAN -->
    <td>{{ account_iban }}</td>
    <!-- NIF -->
    <td>{{ account_nif }}</td>
    <!-- CANTIDAD -->
    <td>{{ fmtAmount(payment.amount) }}</td>
    <!-- ESTADO -->
    <td>{{ payment_status }}</td>
    <!-- ACCIONES -->
    <td>
      <button v-if="can_unlink" @click="unlink" class="btn btn-wabident-round small red">
        <i class="fas fa-undo"></i> Desvinc.
      </button>

      <button v-if="can_pay" @click="pay" class="btn btn-wabident-round small green">
        <i class="fas fa-money-bill-alt"></i> Pagar
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['payment', 'order'],
  data() {
    return {
      payment_statuses: {
        invalid: 'Necesita corrección',
        paid: 'Pagada',
        pending: 'Pendiente',
      }
    }
  },
  computed: {
    can_unlink() {
      return this.order.status == 'xml_pending' || this.order.status == 'invalid';
    },
    can_pay() {
      return this.order.status == 'payment_pending' && this.is_valid && !this.payment.bank_order_payment_id;
    },
    customer() {
      return this.payment.customer;
    },
    sepa_account() {
      return this.customer.sepa_account;
    },
    account_name() {
      if (!this.sepa_account) {
        return null;
      }
      return this.sepa_account.name || null;
    },
    account_iban() {
      if (!this.sepa_account) {
        return null;
      }
      return this.sepa_account.iban || null;
    },
    account_nif() {
      if (!this.sepa_account) {
        return null;
      }
      return this.sepa_account.nif || null;
    },
    is_valid() {
      return this.payment.bank_order_status != 'invalid';
    },
    payment_status() {
      return this.payment_statuses[this.payment.bank_order_status] ?? 'N/D';
    },
  },
  methods: {
    notEmpty(val) {
      return val && val != '';
    },
    fmtAmount(amount) {
      return WabiDent.fmtMoney(amount);
    },
    fmtDate(date) {
      return WabiDent.fmtDate(date);
    },
    unlink() {
      this.$emit('unlink', this.payment);
    },
    pay() {
      this.$emit('pay', this.payment);
    }
  }
}
</script>
